interface GetMonthlyHoursInput {
  weeklyHours: number;
}

export const getMonthlyHours = ({ weeklyHours }: GetMonthlyHoursInput) => weeklyHours * 4;
